import { render, staticRenderFns } from "./personality.vue?vue&type=template&id=9e7bacaa&scoped=true&"
import script from "./personality.vue?vue&type=script&lang=js&"
export * from "./personality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7bacaa",
  null
  
)

export default component.exports